import { fromHttpPromise } from 'pulse/adapters';
import { persistedFetchFrameworkTypes } from 'fdsr-migration-layer';
import { createRpcClientV2 } from 'rpc-client-utils';
export const defaultObjectTypeDefinitionsResolver = fromHttpPromise('objectTypeDefinitionsResolver', httpClient => persistedFetchFrameworkTypes.makeFetchWithOpts({
  refresh: true
})({
  family: 'objects',
  httpClient: httpClient,
  // Passing rpcClient here fixes downstream object-type consumers under the
  // CHIRP migration (crm-object-map #258, framework-app-settings-features-lib,
  // etc.). TODO: remove suppression once the migrated fdsr-migration-layer
  // publishes — its published type does not yet accept rpcClient.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore rpcClient not yet in published fetchFrameworkTypes type
  rpcClient: createRpcClientV2({
    hubHttpClient: httpClient
  })
}));